<div class="row">
    <div class="col-10">
        <mat-label class="label-heading">Legends Table</mat-label>
    </div>
    <div class="col-2">
        <div class="d-flex justify-content-end">
            <mat-icon mat-dialog-close>close</mat-icon>   
        </div>
    </div>
</div>


<table mat-table [dataSource]="legendsTable" class="table-responsive mb-3 mt-3"
style="border: 1px solid #00943a; width: 100%" #graduateTable>

<ng-container matColumnDef="no">
  <th mat-header-cell *matHeaderCellDef style="
      padding: 1rem;
      border-bottom: 1px solid #00943a;
      background-color: #00943a;
      color: #ffffff;
      font-size: 14px;
      "class="text-center"
    >
    No.
  </th>
  <td mat-cell *matCellDef="let item; let i = index" class="table-cell text-center"
    style="padding: 1rem; border-bottom: 1px solid #00943a">
    {{ i + 1 }}
  </td>
</ng-container>

<ng-container matColumnDef="icon">
  <th mat-header-cell *matHeaderCellDef style="
      padding: 1rem;
      border-bottom: 1px solid #00943a;
      background-color: #00943a;
      color: #ffffff;
      font-size: 14px;
    " class="text-center">
    Icon
  </th>
  <td mat-cell *matCellDef="let legendsTable" style="padding: 1rem; border-bottom: 1px solid #00943a"
    class="text-center">
    <mat-icon *ngFor="let icon of legendsTable.icons">{{ icon }}</mat-icon>
  </td>
</ng-container>

<ng-container matColumnDef="meaning">
  <th mat-header-cell *matHeaderCellDef style="
      padding: 1rem;
      border-bottom: 1px solid #00943a;
      background-color: #00943a;
      color: #ffffff;
      font-size: 14px;
    " class="text-center">
    Meaning
</th>
  <td mat-cell *matCellDef="let legendsTable" class="table-cell text-center"
    style="padding: 1rem; border-bottom: 1px solid #00943a" data-cell="Major">
    {{ legendsTable.meaning }}
</td>
</ng-container>


<tr mat-header-row *matHeaderRowDef="displayedColumnLegends"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumnLegends"></tr>
<!-- Add Item table row -->
</table>

